import Icon from '@ant-design/icons';
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

import { WatchSvg } from './svg/watch';

export const WatchIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={WatchSvg} {...props} />
);
